module.exports = __webpack_public_path__ + "media/images/vp/icon.document.red-94cb91e31e013e3e37e249aea131cefa.svg";